import { render } from "./StandardV2Home.vue?vue&type=template&id=e966085c&scoped=true"
import script from "./StandardV2Home.vue?vue&type=script&lang=js"
export * from "./StandardV2Home.vue?vue&type=script&lang=js"

import "./StandardV2Home.vue?vue&type=style&index=0&id=e966085c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e966085c"]])

export default __exports__